import React from "react";
import { Fab, Tooltip } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppButton = () => {
  const whatsappNumber = "9133959551"; 
  const message = "Hello! I would like to get service details.";

  const handleClick = () => {
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <Tooltip title="Chat with us on WhatsApp" placement="left">
      <Fab
        color="success"
        aria-label="whatsapp"
        onClick={handleClick}
        sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            backgroundColor: "#25D366",
            width: "64px",  
            height: "64px",
            "&:hover": {
              backgroundColor: "#20b857",
            },
            boxShadow: "0px 8px 18px rgba(0, 0, 0, 0.15)", 
            zIndex: 1000,
            "::before": {
              content: '""',
              position: "absolute",
              width: "120px",  
              height: "120px", 
              borderRadius: "50%",
              // background: "rgba(37, 211, 102, 0.8)", // WhatsApp green color with transparency
              top: "50%",
              left: "50%",
              // transform: "translate(-50%, -50%) scale(1)",
              // animation: "ripple 1.8s infinite ease-out",
              zIndex: -1,
            },
          }}
      >
        <WhatsAppIcon sx={{ fontSize: 40 }} />
      </Fab>
    </Tooltip>
  );
};

export default WhatsAppButton;
